import { PDFDocument, PDFTextField, PDFCheckBox, StandardFonts, rgb} from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import {DeminimisMapper} from '../mappers/DeminimisMapper'
import font from './Signika-Regular.ttf'

const classRegistry = {
  DeminimisMapper
};

async function generateAndShowPdf(pdf, mapper) {
    const existingPdfBytes = await fetch(pdf).then(res => res.arrayBuffer());
    const fontBytes = await fetch(font).then((res) => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit);
    const customFont = await pdfDoc.embedFont(fontBytes,{ subset: true });
    const form = pdfDoc.getForm();
    const pages = pdfDoc.getPages();


    console.log(mapper);
    for (const [key, value] of Object.entries(mapper)) {

      //dodanie tekstu zamiasta uzueplnienie pola
      if (typeof value === 'object' && value.hasOwnProperty('x') &&
        value.hasOwnProperty('y') &&
        value.hasOwnProperty('page')) {
        const firstPage = pages[value.page];

        firstPage.drawText(value.text, {
          x: value.x,
          y: value.y,
          size: 12,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }
      else {
        const field = form.getField(key);

        if (!field) {
          console.warn(`Pole "${key}" nie istnieje w formularzu.`);
          continue;
        }
  
        if (field instanceof PDFTextField) {
          field.setText(value ?? '');
          field.defaultUpdateAppearances(customFont);
          field.setFontSize(12);
  
        } else if (field instanceof PDFCheckBox) {
          if (value) {
            field.check();
          }
        } else {
          console.warn(`Typ pola "${key}"  nieobsługiwany.`);
        }
      }

  }
    // form.updateFieldAppearances(customFont);

    const fields = form.getFields()
    fields.forEach(field => {
      // if(field instanceof PDFTextField)
      // {
      //   field.setFontSize(12);
      // }
      field.enableReadOnly();

    })    

    form.updateFieldAppearances(customFont);


    const pdfBytes = await pdfDoc.save();
  
    // Stwórz blob i otwórz w nowej karcie
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
}


document.querySelectorAll('.generate_pdf').forEach(element => {
    element.addEventListener('click', async function () {

      const mapperClass = this.form.dataset.pdfmapper; //class mapper
      if(classRegistry[mapperClass])
      {
        const text = this.innerText;
  
        this.innerHTML = '<p class="spinner-border"></p>';
  
        // Usuń stary error, jeśli istnieje
        const oldError = this.parentNode.querySelector('#pdf-error');
        if (oldError) oldError.remove();
  
        try {
          const Mapper = new classRegistry[mapperClass](this.form);
        console.log(Mapper);
          await generateAndShowPdf('/pdf/wzor_informacji_o_pomocy.pdf', Mapper.getMapper());
        } catch (err) {
          console.error("Błąd przy generowaniu PDF:", err);
  
          const errorDiv = document.createElement('div');
          errorDiv.id = 'pdf-error';
          errorDiv.textContent = err.message;
          errorDiv.className = 'mt-2 text-danger';
          this.insertAdjacentElement('afterend', errorDiv);
        } finally {
          this.innerHTML = text;
        }
      }
    
    })


}); 

window.generateAndShowPdf = generateAndShowPdf;